/**
 * @generated SignedSource<<5d44c2ad9114842a0f3925c1801e7a0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarSoldItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsColumns_viewer" | "useShouldShowSimilarSoldItems_viewer" | "useSimilarSoldItemsTracking_viewer">;
  readonly " $fragmentType": "PdpRespSimilarSoldItems_viewer";
};
export type PdpRespSimilarSoldItems_viewer$key = {
  readonly " $data"?: PdpRespSimilarSoldItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarSoldItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarSoldItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldShowSimilarSoldItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSimilarSoldItemsColumns_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSimilarSoldItemsTracking_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "821a478cc003143f52df6d0fac9ef1a2";

export default node;
